/* eslint-disable prettier/prettier */
import { useEffect, useState } from 'react'

import { brandsService } from 'services'
import { _object } from 'utils/interfaces'
import { InputField } from './form-inputs'
import { useFormik } from 'formik'
import { Placeholder } from 'assets/images'

const BrandSlab = () => {
  const [brand, setBrand] = useState<_object>({})
  const [loading, setLoading] = useState(false)

  const getCategories = () => {
    setLoading(true)
    brandsService.getBrands({ per_page: 999 }).then((results: _object) => {
      setLoading(false)
      setBrand(results)
    })
  }

  useEffect(() => {
    getCategories()
  }, [])

  const handleChange = (value: any, item: any) => {
    brandsService.UpdateBrand(item.id, { title: item.title, featured: value })
      .then((result: _object) => {
        if (result.error === false) {
          getCategories()
        }
      })
  }

  const formik: any = useFormik({
    initialValues: {
      title: '',
    },
    enableReinitialize: true,
    onSubmit: (values) => {
      brandsService?.brandHomePageText({ key: "brand_feature", value: { title: values.title } }).then((result) => { console.log('>>>>>>>>>>>', result) })
    }
  })

  return (
    <>
      <div className="">
        <form onSubmit={formik.handleSubmit} className='flex gap-2 my-auto'>
          <InputField
            name="title"
            type="text"
            placeholder="Write title for featured brand section"
            value={formik.values.title}
            onChange={formik.handleChange}

          />

          <button
            className="rounded-md border border-purple-900 bg-purple-900 hover:bg-purple-950 px-4 py-2 my-1text-sm text-white h-fit font-medium text-sm"
            type="submit"
          >
            Submit
          </button>
        </form>
        <div className='rounded-lg bg-white shadow overflow-x-auto'>
          <table className="min-w-full divide-y divide-gray-200">
            <thead className="bg-gray-100">
              <tr className="text-left text-sm font-medium text-gray-900">
                <th className="px-4 py-3 font-semibold">#</th>
                <th className="text-semibold px-4 py-3 text-start">
                  <p className="ms-4 text-sm font-semibold text-gray-900">Logo</p>
                  <span className="whitespace-nowrap mb-2 text-[10px] text-[#969494] font-medium">275W × 183H | 3:2</span>
                </th>
                <th className="px-4 py-3 font-semibold">Name</th>
                <th className="px-4 py-3 font-semibold">Featured</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-100 text-sm">
              {loading === false ? (
                brand?.items?.map((item: _object, i: number) => {
                  return (
                    <tr className="hover:bg-gray-50" key={i}>
                      <td className="px-4 py-3">{i + 1}</td>
                      <td className="px-4 py-3">
                        <div className="h-[50px] w-[50px]">

                          <img src={item.image || Placeholder} alt={item.title} className="rounded-md h-full w-full object-cover" />
                        </div>

                      </td>
                      <td className="px-4 py-3">{item.title}</td>
                      <td className="px-4 py-3">
                        <label className="inline-flex cursor-pointer items-center">
                          <input
                            type="checkbox"
                            // value={item?.home_page_display}
                            className="peer sr-only"
                            onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                              handleChange(e.target.checked, item)
                            }
                            checked={item?.featured}
                          />
                          <div className="peer relative h-6 w-11 rounded-full bg-gray-200 peer-checked:bg-purple-900 peer-focus:ring-0 peer-focus:ring-purple-900 peer-focus:outline-none after:absolute after:start-[2px] after:top-[2px] after:h-5 after:w-5 after:rounded-full after:border after:border-gray-300 after:bg-white after:transition-all after:content-[''] peer-checked:after:translate-x-full peer-checked:after:border-white rtl:peer-checked:after:-translate-x-full dark:border-gray-600 dark:bg-gray-700 dark:peer-checked:bg-purple-900 dark:peer-focus:ring-purple-900"></div>
                        </label>
                      </td>

                    </tr>
                  )
                })
              ) : (
                <SliderSkeleton />
              )}
              {brand?.items?.length <= 0 &&
                <td colSpan={12} className="text-center py-6 text-gray-500">
                  <p>No record found</p>
                </td>}
            </tbody>
          </table>
        </div>
      </div>
    </>
  )
}
export default BrandSlab

const SliderSkeleton = () => {
  return (
    <>
      <tr className="animate-pulse">
        <td className="px-4 py-3">
          <div className="h-4 w-6 rounded bg-gray-300"></div>
        </td>
        <td className="px-4 py-3">
          <div className="h-4 w-32 rounded bg-gray-300"></div>
        </td>
        <td className="px-4 py-3">
          <div className="h-4 w-12 rounded bg-gray-300"></div>
        </td>
        <td className="px-4 py-3">
          <div className="h-4 w-12 rounded bg-gray-300"></div>
        </td>
      </tr>
    </>
  )
}
